// Nº de socio de cara al club — regla única: se pinta y se busca el MISMO número.
// Manda el de Gestión Verde (legacy_member_id) si existe (socios migrados); si no,
// el interno de la plataforma (membership_id — para las altas nuevas ESE es su
// número). profile.client_id (membership serializado) cubre payloads antiguos.
// `||` a propósito: un legacy vacío ("") de la migración cae al interno, no a un
// badge en blanco.
export function socioNum(u) {
	return u?.legacy_member_id || u?.membership_id || u?.profile?.client_id || null;
}

// El nº de socio SOLO significa algo en el club donde se emitió: es único por club
// (`uq_venue_membership_id` en la BD), no globalmente. Pintar el de alguien cuyo club
// de origen es otro produce "duplicados" que no lo son —dos personas de dos clubes
// distintos traen las dos su "2"— y además no es su número AQUÍ. Reporte CRUO 18-ago.
// Sin club de origen (superadmins, `venue_id` NULL) tampoco hay número que enseñar.
export function socioNumDelClub(u, venueId) {
	if (!venueId || !u?.venue_id) return null;
	return String(u.venue_id) === String(venueId) ? socioNum(u) : null;
}
